module.exports = __webpack_public_path__ + "img/report_image_advice_d@2x.bbeb1226.png";